import { render, staticRenderFns } from "./RemarkCard.vue?vue&type=template&id=09ff4dd5&scoped=true&"
import script from "./RemarkCard.vue?vue&type=script&lang=js&"
export * from "./RemarkCard.vue?vue&type=script&lang=js&"
import style0 from "./RemarkCard.vue?vue&type=style&index=0&id=09ff4dd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff4dd5",
  null
  
)

export default component.exports